import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash.get';

import { requestFundsPayout } from 'modules/requestFunds';
import { formatMoney } from 'utils/formatMoney';

import LoadingOverlay from 'components/LoadingOverlay';
import FieldError from 'components/FieldError';
import Messages from 'components/Messages';

class FundAmount extends Component {
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
		isFundLoading: PropTypes.bool.isRequired,
		isFormLoading: PropTypes.bool.isRequired,
		isSuccess: PropTypes.bool.isRequired,
		errors: PropTypes.object.isRequired,
		funds: PropTypes.number,
		bank_account: PropTypes.string
	};

	static defaultProps = {
		funds: 0,
		bank_account: ''
	};

	constructor(props) {
		super(props);

		this.state = {
			isShowRequestForm: false
		};
	}

	/**
	 * Toggle request form visibility
	 */
	toggleForm = (e) => {
		e.preventDefault();

		this.setState({
			amount: 0,
			isShowRequestForm: ! this.state.isShowRequestForm
		});
	};

	/**
	 * On amount input changed
	 */
	onInputChanged = (e) => {
		const target = e.target;
		const value = target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	};

	/**
	 * Submit the form
	 */
	submitForm = (e) => {
		e.preventDefault();
		const { dispatch } = this.props;
		const { amount } = this.state;
		dispatch(requestFundsPayout(amount));
		this.setState({ amount: 0 });
	};

	/**
	 * Render the request form
	 */
	renderForm() {
		const { errors, isSuccess, bank_account } = this.props;

		// Error message
		const errorMessage = get(errors, 'data.message') ? errors.data.message : '';

		return (
			<div className="grid mt-20">
				<form className="grid__item large--one-half" onSubmit={this.submitForm}>
					{ errorMessage && <div className="mb-30"><FieldError text={errorMessage} /></div> }
					{ isSuccess && <Messages type="success">Permintaan penarikan saldo berhasil dikirim</Messages> }

					<div className="form-row form-row-wide">
						<label className="form-label" htmlFor="amount">Jumlah saldo yang ingin ditarik</label>
						<input
							type="number"
							className="form-field form-field--text form-field--full mb-10"
							name="amount" 
							id="amount"
							value={this.state.amount}
							onChange={this.onInputChanged}
						/>
						Saldo akan ditransfer ke rekening bank<br/>
						<strong>{bank_account}</strong>
					</div>

					<div className="form-row form-row-wide">
						<input
							type="submit"
							className="button button--small button--uppercase"
							name="submit"
							value="Submit"
							onClick={this.submitForm}
						/>
					</div>
				</form>
			</div>
		);
	}

	/**
	 * Render main layout
	 */
	render() {
		const { funds, isFundLoading, isFormLoading } = this.props;
		const { isShowRequestForm } = this.state;
		const showFundLoading = (isFundLoading || isFormLoading) ? 'show' : '';

		return (
			<div className={`form-wrapper ${showFundLoading}`}>
				<div className="form-wrapper__inner">
					<div className="wallet-page__header pb-30 pt-0">
						<div className="text-medium text-color-gray-1">Saldo Kamu</div>
						<div className="wallet-amount">{formatMoney(funds)}</div>
						<button className="button button--primary button--small" onClick={this.toggleForm}>Tarik Saldo</button>

						{ isShowRequestForm && this.renderForm() }
					</div>
				</div>

				<LoadingOverlay />
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const { isLoading: isFundLoading } = state.user;
	const { isLoading: isFormLoading, errors, isSuccess } = state.requestFunds;
	const { funds, bank_account } = state.user.user;

	return {
		isFundLoading,
		isFormLoading,
		errors,
		isSuccess,
		funds,
		bank_account
	};
};

export default connect(mapStateToProps)(FundAmount);


// WEBPACK FOOTER //
// ./src/pages/Funds/FundAmount/index.js